/**
 * Load Third Party Scripts dynamically
 */
export default class ThirdPartyScriptsChunk {
  static body: HTMLElement;

  static link: HTMLElement;

  constructor() {
    ThirdPartyScriptsChunk.body = document.querySelector('body');

    import(
      /* webpackPreload: true */ /* webpackChunkName: 'preload-axeptio' */ '../../../../../../assets/js/modules/tihrd-party-scripts/axeptio'
    ).then(({ default: axeptio }) => {
      axeptio();

      ThirdPartyScriptsChunk.link =
        document.querySelector('.js-axeptioCookies');

      if (ThirdPartyScriptsChunk.link) {
        /* Active Cookies Box on click link */
        ThirdPartyScriptsChunk.link.addEventListener('click', (event) => {
          event.preventDefault();
          // @ts-ignore
          // eslint-disable-next-line no-undef
          openAxeptioCookies();
        });
      }
    });
    const isProductPage =
      ThirdPartyScriptsChunk.body.classList.contains('l-product');
    const isNewCheckout = !!document.querySelector('.l-checkout');

    setTimeout(() => {
      if (
        !ThirdPartyScriptsChunk.body.classList.contains('mobile') &&
        !isProductPage &&
        !isNewCheckout
      ) {
        import(
          /* webpackPreload: true */ /* webpackChunkName: 'preload-google-badge' */ '../../../../../../assets/js/modules/tihrd-party-scripts/google-badge'
        ).then(({ default: googleBadge }) => {
          // eslint-disable-next-line new-cap
          new googleBadge();
        });
      }
    }, 5000);
  }
}
